import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators} from "@angular/forms";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {TaskService} from "../../../core/services/task.service";
import {GeneralService} from "../../../core/services/general.service";
import {TableService} from "../../../core/services/table.service";
import {DropzoneConfigInterface, DropzoneModule} from "ngx-dropzone-wrapper";
import {environment} from "../../../../environments/environment";
const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Component({
  selector: 'app-new',
  standalone: true,
  imports: [NgbModule, FormsModule, NgIf, DatePipe, NgForOf, ReactiveFormsModule, DropzoneModule],
  templateUrl: './new.component.html',
  styleUrl: './new.component.scss'
})
export class NewComponent implements OnInit{
  @Input() confirmAction!: () => void;
  @Input() data: any;
  idNewRow: boolean = true;
  areaOptions: any[] = [];
  userOptions: any[] = [];
  public taskForm: FormGroup;
  evidencesUploaded: string[] = [];
  textDropzone = '<i class="icon-cloud-up"></i>';
  public config: DropzoneConfigInterface = {
    clickable: true,
    addRemoveLinks: true,
    dictRemoveFile: 'Eliminar archivo',
    url: `${END_POINT}/task/upimages`,
    method: 'post',
    maxFilesize: 5,
    acceptedFiles: 'image/*,application/pdf',
    paramName: 'file',
    headers: {
      'X-Api-Key': `${API_KEY}`,
    }
  };

  constructor(public activeModal: NgbActiveModal, private taskService: TaskService, private generalService: GeneralService, private tableService: TableService, private fb: FormBuilder) {
    this.taskForm = this.fb.group({
      id: [null], // ID autoincremental (solo en edición)

      //created_by_user_id: [null], // Usuario que crea la tarea
      responsible_area: [null, Validators.required], // Área responsable (configurable)
      assigned_user_id: [null, Validators.required], // Usuario responsable

      title: [null, [Validators.required, Validators.maxLength(255)]], // Título corto
      description: [null], // Comentarios generales

      due_date: [null, Validators.required], // Fecha límite
      status: ['Abierto', Validators.required], // Estado actual: Abierto, En proceso, Finalizado

      // Solo se llenan automáticamente o cuando cambia el estado
      //started_at: [null],
      //started_by_user_id: [null],
      //completed_at: [null],
      //completed_by_user_id: [null],

      closing_comments: [null], // Comentarios al finalizar la tarea
      evidence: [],
      evidenceDelete: [],
    });
  }

  ngOnInit(): void {
    if(this.data){
      this.idNewRow = false;
      this.edit(this.data);
    }
    //Cargar usuarios
    this.getList();
    //Cargar areas
    this.loadArea();
  }

  //Función para cancelar nuevo registro
  cancelForm(): void {
    this.taskForm.reset();
  }

  submitForm() {
    if (this.taskForm.valid) {
      // Actualiza el form con el nuevo array
      this.taskForm.patchValue({
        evidence: this.evidencesUploaded
      });
      // Delete
      this.taskForm.patchValue({
        evidenceDelete: this.evidencesDelete
      })
      this.taskService.add(this.taskForm.value).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              this.confirmAction()
            }
          },
          (err) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    } else {
      this.taskForm.markAllAsTouched();
      this.generalService.showMessage('warn', 'LLene toda la información solicitada');
    }
  }

  //Función para obtener los eventos del servicio
  getList() {
    this.taskService.getList().subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.userOptions = res.message;
          }
        },
        (err: any) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    );
  }

  //Función para obtener lista configurable
  loadArea():void {
    this.tableService.loadSelectOptions({"conditionColumn":"configurableListsField",
      "conditionValue":"Área de una tarea",
      "idColumn":"idconfigurableLists",
      "table":"confList",
      "valueColumn":"configurableListsCode"}).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            this.areaOptions = [];
          } else {
            this.areaOptions = res['message'];
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          this.areaOptions = [];
        }
    );
  }

  //DropZone
  dropzoneInstance: any; // Esto será la instancia real de Dropzone
  onDropzoneInit(dropzone: any): void {
    this.dropzoneInstance = dropzone;
  }
  onUploadError(args: any): void {
    console.log('warn', args);
  }

  onUploadSuccess(event: any): void {
    let file = event[0];
    let response = event[1]; // Aquí viene el `response`

    if (response.success) {
      event.serverFileName = response.name;
      this.evidencesUploaded.push(response.url);
    }
  }
  evidencesDelete: string[] = [];
  onRemoveSuccess(file: any): void {
    const nombreArchivo = file.serverFileName; // Un campo extra que vamos a poner al subir
    this.evidencesDelete.push(nombreArchivo);
    const index = this.evidencesUploaded.findIndex(url => url.includes(nombreArchivo));
    // Si lo encuentra, lo remueve
    if (index > -1) {
      this.evidencesUploaded.splice(index, 1);
    }
  }
  edit(item: any): void {
    this.taskForm.patchValue({
      id: item.id, // ID autoincremental (solo en edición)
      responsible_area: item.responsible_area, // Área responsable (configurable)
      assigned_user_id: item.assigned_user_id, // Usuario responsable
      title: item.title, // Título corto
      description: item.description, // Comentarios generales
      due_date: item.due_date, // Fecha límite
      status: item.status, // Estado actual: Abierto, En proceso, Finalizado
      closing_comments: item.closing_comments, // Comentarios al finalizar la tarea
    });

    // Añadirlo al Dropzone manualmente
    let evidenceList = item.evidence_urls
        ? item.evidence_urls.split(',').map((e: string) => e.trim()).filter((e: any) => !!e)
        : [];

    this.evidencesUploaded = evidenceList;
    this.taskForm.patchValue({
      evidence: evidenceList
    });
    this.evidencesDelete = [];
    this.taskForm.patchValue({
      evidenceDelete: this.evidencesDelete
    });

    // Esperar a que Dropzone esté montado (en caso de estar oculto antes)
    setTimeout(() => {
      const dropzoneEvidenceList = this.taskForm.value.evidence;

      if (this.dropzoneInstance && dropzoneEvidenceList.length) {
        this.dropzoneInstance.removeAllFiles(true);

        dropzoneEvidenceList.forEach((url: string) => {
          const filename = this.getFileNameFromUrl(url);
          const mockFile = {
            name: filename,
            size: 123456,
            accepted: true,
            serverFileName: filename
          };

          this.dropzoneInstance.emit("addedfile", mockFile);

          const isImage = url.match(/\.(jpeg|jpg|png|gif)$/i);
          if (isImage) {
            this.dropzoneInstance.emit("thumbnail", mockFile, url);
          } else {
            this.dropzoneInstance.emit("thumbnail", mockFile, "assets/pdf-icon.png");
          }

          this.dropzoneInstance.emit("complete", mockFile);
        });
      }
    }, 300);
  }
  getFileNameFromUrl(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1);
  }

}
